import { render, staticRenderFns } from "./RuleAlert.vue?vue&type=template&id=2f3a0ba4"
import script from "./RuleAlert.vue?vue&type=script&lang=js"
export * from "./RuleAlert.vue?vue&type=script&lang=js"
import style0 from "./RuleAlert.vue?vue&type=style&index=0&id=2f3a0ba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports